import axios from 'axios'

const API = process.env.API_URL

const config = {
  headers: {
    'Accept': 'application/ldjson',
    'Cache-Control': 'no-transform'
  }
}

const auth = {
  connect (creds) {
    return axios.post(`${API}/login`, creds, {
      config
    })
  },

  connectWithSSO (provider) {
    window.location = `${API}/login/external?provider=${provider}`
  },

  updateToken (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },

  checkStatus (token) {
    return axios.post(`${API}/checkStatus`, { token }, {
      config
    })
  }
}

export { auth }



// WEBPACK FOOTER //
// ./src/api/index.js